export const initialTimemachineState = {
  enabled: false,
  id: "",
  layerId: "",
  attribute: "",
  type: "interval",
  format: "second",
  min: 0,
  max: 0,
  range: [0, 0],
  point: 0,
  allCount: 0,
  chunks: [],
  fieldChanged: false,
  isNested: false,
  sourceName: null,
  sourceId: null
};

export const speeds = [
  { id: 1, value: 1, label: "1x" },
  { id: 2, value: 2, label: "2x" },
  { id: 3, value: 4, label: "4x" }
];

export const playingTypes = [
  { id: 1, value: "point" },
  { id: 2, value: "interval" }
];

export const timeFormats = ["second", "minute", "hour", "day", "month", "year"];

export const timeFormatConfigs = {
  second: "DD-MM-YYYY HH:mm:ss",
  minute: "DD-MM-YYYY HH:mm",
  hour: "DD-MM-YYYY HH",
  day: "DD-MM-YYYY",
  month: "MM-YYYY",
  year: "YYYY"
};
